import React, { useState } from 'react';
import { supabase } from '../../utils/supabase';
import { Button, Modal, ModalContent, ModalCloseButton } from './';

const VerificationModal = ({ email, onClose }) => {
  const [resendStatus, setResendStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleResendEmail = async () => {
    if (!email) return;
    
    setLoading(true);
    try {
      const { error } = await supabase.auth.resend({
        type: 'signup',
        email: email
      });
      
      if (error) throw error;
      setResendStatus('Verification email resent successfully!');
    } catch (err) {
      console.error('Error resending verification email:', err);
      setResendStatus(`Failed to resend: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalContent size="small">
        <ModalCloseButton onClose={onClose} />
        <h2 className="text-xl font-bold text-text-primary mb-4">Verify Your Email</h2>
        
        <div className="bg-info-light border border-info/40 rounded-md p-4 mb-6">
          <p className="text-info-dark mb-2">
            <span className="font-semibold">Almost there!</span> We've sent a verification email to:
          </p>
          <p className="font-medium text-info-dark text-center my-2">{email || 'your email address'}</p>
          <p className="text-info-dark mt-2">
            Please check your inbox and click the verification link to complete your registration.
          </p>
        </div>

        <div className="mb-6">
          <h3 className="text-lg font-semibold text-text-primary mb-2">What's next?</h3>
          <ol className="list-decimal pl-5 text-text-secondary space-y-2">
            <li>Check your email inbox (and spam folder)</li>
            <li>Click the verification link in the email</li>
            <li>Once verified, you can log in to your account</li>
          </ol>
        </div>

        <div className="border-t border-border-medium pt-4 mt-4">
          <p className="text-text-secondary mb-4">Didn't receive the email?</p>
          <Button 
            onClick={handleResendEmail}
            disabled={loading}
            variant="primary"
            className="w-full"
          >
            {loading ? 'Sending...' : 'Resend Verification Email'}
          </Button>
          
          {resendStatus && (
            <p className={`mt-3 text-sm text-center ${resendStatus.includes('Failed') ? 'text-red-600' : 'text-green-600'}`}>
              {resendStatus}
            </p>
          )}
        </div>

        <div className="mt-6 text-center">
          <button
            onClick={onClose}
            className="text-primary hover:text-primary-dark font-medium"
          >
            Return to Login
          </button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default VerificationModal;
